let Hooks = {}

Hooks.Download = {
    mounted() {
        this.handleEvent("download_blob", (event) => {
            const blob = new Blob([event.blob], {type: event.type});
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.setAttribute("href", url);
            link.setAttribute("download", event.filename);
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    }
}

export {Hooks}